import React from "react";
import helpCenter from "../assets/images/Help-Center.png"


const HelpCenter = ({contactUsRef}) => {
  const scrollToSection = (sectionRef) => {
    if (sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div
    id="helpcenter"
    className="bg-white container max-w-full mx-auto -mt-12"
    key="helpcenter-section"
  >
    <div
      className="container mx-auto px-4 mt-10 pt-10"
      key="help-section-first-12"
    >
      <h1 className="text-center text-2xl lg:text-3xl font-bold mb-1">
        Help Center
      </h1>

      <div
        className="container flex flex-col md:flex-row justify-center items-center md:p-8"
        key="help-section-first-13"
      >
      <div className="p-10 -mr-2">
      <img
        src={helpCenter}
        alt="Customer help center"
        width={551}
        height={521}
      />
    </div>
      <div
      className="my-4 md:my-0 text-center md:text-left"
      key="help-section-first-14"
    >
      <h2 className="text-base md:text-lg font-extrabold ">
      <span className="font-bold text-[#E53A36] text-3xl smart-text">S</span>
      <span className="font-bold text-3xl smart-text">mart</span>
      <span className="font-bold text-[#E53A36] text-3xl smart-text">S</span>
      <span className="font-bold text-3xl smart-text">pend Help Center</span>
       
      </h2>
      <p
        className="text-md mt-2 text-lg md:text-xl text-black md:mt-4 max-w-sm  help-text"
        key="help-section-first-15"
      >
      Regular updates and user manuals are <br/>readily available for your convenience.

      </p>
      <div
        className="flex justify-center mt-4 md:justify-start"
        key="help-section-first-16"
      >
        <button
          className="text-white bg-[#1380E7] hover:bg-[#484647]  focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center md:text-left "
          type="submit"
          onClick={() => scrollToSection(contactUsRef)}
          key="contact-us"
        >
          HELP CENTER
        </button>
      </div>
    </div>
     
     
      </div>
    </div>
  </div>
  );
};

export default HelpCenter;
